export type SpinnerVariantsSize = "sm" | "md";

export const SpinnerVariants: Record<SpinnerVariantsSize, string> = {
    sm: "tw:w-4 tw:h-4 tw:border-[calc(--spacing(1)-20%)]",
    md: "tw:w-8 tw:h-8 tw:border-[calc(--spacing(1))]"
};
